import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert } from "@redux/app/appSlice";
import { useTranslation } from "react-i18next";
import {
	Modal,
	ModalFooterContainer,
	ModalText,
	ModalTitle,
} from "./Alert.style";

// const Modal = styled(AntModal)`

// .ant-modal-title {
//     text-align: center;
//     color: ${props => props.theme.primarySolid};
//     text-transform: capitalize;
// }

// .ant-modal-body {
//     padding: 8px 0;
//     text-align: center;
//     color: ${props => props.status === 'error' ? 'red' : '#000'};
// }

// .ant-modal-footer {
//     text-align: center;

//     .ant-btn {
//         min-width: 76px;
//     }

//     .ant-btn-default {
//         display: none !important;
//     }
// }
// `;

const Alert = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { open, message, isError, successCallback } = useSelector(
		(state) => state.app.alert
	);

	const handleClose = () => dispatch(closeAlert());

	const onOk = () => {
		successCallback && successCallback();
		handleClose();
	};

	return (
		<Modal
			centered
			destroyOnClose
			closable={false}
			width={300}
			open={open}
			onOk={onOk}
			footer={null}
			okText={t("common.ok")}
			status={isError ? "error" : "success"}
		>
			<div style={{ textAlign: "center" }}>
				<ModalTitle>
					{isError ? t("common.notice") : t("common.success")}
				</ModalTitle>
				<ModalText>{message}</ModalText>
			</div>
			<ModalFooterContainer onClick={onOk}>{t("common.ok")}</ModalFooterContainer>
		</Modal>
	);
};

export default Alert;
